export default {
  install(Vue) {
    // safri 输入法收缩后下面空白移位
    var timerid = null
    Vue.directive('safri', {
      inserted: function(el) {
        var els = []
        if (el.tagName != 'INPUT') {
          els = el.getElementsByTagName('input')
        } else {
          els = [el]
        }
        if (els) {
          for (var i = 0; i < els.length; i++) {
            var item = els[i]
            if (!/iphone/i.test(navigator.userAgent)) {
              return
            }
            item.addEventListener('focus', () => {
              if (timerid) {
                clearTimeout(timerid)
              }
            })
            item.addEventListener('blur', () => {
              timerid = setTimeout(() => {
                document.body.scrollTop++
                window.scrollBy(1, 1)
              }, 100)
            })
          }
        }
      }
    })

    var time = null
    Vue.directive('shake', {
      bind: function(el, binding, vnode) {
        el.addEventListener('click', () => {
          var current = Date.parse(new Date())
          if (time && current - time < 500) {
            return
          }
          time = current
          binding.value()
        })
      }
    })

    Vue.directive('touch', {
      bind: function(el, binding, vnode) {
        var type = binding.arg;
        var up = binding.modifiers["up"];
        var down = binding.modifiers["down"];
        var left = binding.modifiers["left"];
        var right = binding.modifiers["right"];

        var callback = binding.value;
        var time_start, time_end;
        var touch_start, touch_end;
        var max_else = 0;
        var s_max_else = 30; //另一条轴的偏移距离;
        var s_min = 50; //手势滑动最小距离，小于不触发
        if (["swipe", "move"].indexOf(type) >= 0) {
          el.addEventListener("touchstart", (e) => {
            time_start = Date.parse(new Date());
            touch_start = e.changedTouches[0];
            max_else = 0;
          })
        }

        if (["swipe", "move"].indexOf(type) >= 0) {
          el.addEventListener("touchmove", (e) => {
            e.preventDefault();
            if ("swipe" == type) {
              if (up || down) {
                var d = Math.abs(e.changedTouches[0].clientX - touch_start.clientX);
                if (max_else < d) {
                  max_else = d;
                }
              }
            }

            if ("move" == type) {
              var d = e.changedTouches[0].clientY - touch_start.clientY;
              callback({
                distance: Math.abs(d),
                direction: d > 0 ? "down" : "up"
              })
            }
          })
        }

        if ("swipe".indexOf(type) >= 0) {
          el.addEventListener("touchend", (e) => {
            time_end = Date.parse(new Date());
            touch_end = e.changedTouches[0];

            var time = time_end - time_start;
            var t_p = (up || down) ? "clientY" : "clientX";
            var distance = touch_end[t_p] - touch_start[t_p];
            var distance_else = 0;

            var isMatch = false;
            if (down) {
              isMatch = distance > 0;
            } else if (up) {
              isMatch = distance < 0;
            }
            //手势滑动超过一定距离，且另外一条轴距离小于一定距离，例如向上或者向下滑动的同时x轴不能偏太远
            //尽量保证互动一条直线
            var d_abs = Math.abs(distance);

            if (d_abs >= s_min && callback && isMatch && max_else < s_max_else && Math.abs(max_else) < d_abs) {
              callback({
                time: time,
                distance: d_abs
              })
            }
          })
        }
      }
    })
  }
}
